import { withPlugins, domEvents } from '@spon/plugins';
import domify from 'domify';
import gsap from 'gsap';
import { eventBus } from '@spon/plugins';

function CardHover({ node, plugins: { addEvents, removeEvents } }) {
	let isHovered = false;
	let currentTarget = null;

	// Store target positions
	const targetPos = {
		x: window.innerWidth / 2,
		y: window.innerHeight / 2,
		scrollY: window.lenis?.scroll ?? 0,
		size: {
			w: 0,
			h: 0,
		},
	};

	// Create marker element once
	const marker = domify(
		'<span class="fixed z-[48] top-0 left-0 inline-block pointer-events-none" data-readmore></span>'
	);
	document.body.appendChild(marker);

	eventBus.on('scroll:update', e => {
		targetPos.scrollY = e.scroll;
	});

	const xTo = gsap.quickTo(marker, 'x', {
		duration: 0.2,
		ease: 'power2.out',
	});
	const yTo = gsap.quickTo(marker, 'y', {
		duration: 0.2,
		ease: 'power2.out',
	});

	function updateMarkerPosition() {
		const x = targetPos.x - targetPos.size.w / 2;
		const y = targetPos.y - targetPos.size.h / 2;

		xTo(x);
		yTo(y);

		// Check if mouse is still over the element
		if (currentTarget && isHovered) {
			const rect = currentTarget.getBoundingClientRect();
			const isOver =
				targetPos.x >= rect.left &&
				targetPos.x <= rect.right &&
				targetPos.y >= rect.top &&
				targetPos.y <= rect.bottom;

			if (!isOver) {
				onMouseOut();
			}
		}
	}

	function onMouseOver(event, el) {
		const size = el.dataset.cardSize || '';

		currentTarget = el;
		const words = el.dataset.cardHover || 'Read the article';

		marker.innerHTML = `<span class="o-btn o-btn--sm o-btn--read-more ${size}">${words}</span>`;
		targetPos.size.w = marker.clientWidth;
		targetPos.size.h = marker.clientHeight;

		marker.classList.add('show');
		isHovered = true;

		gsap.ticker.add(updateMarkerPosition);
	}

	function onMouseOut() {
		isHovered = false;
		currentTarget = null;

		marker.classList.remove('show');

		gsap.ticker.remove(updateMarkerPosition);
	}

	function onMouseMove({ clientX, clientY }) {
		targetPos.x = clientX;
		targetPos.y = clientY;
	}

	// Initial setup
	if (window.matchMedia('(pointer: fine)').matches) {
		addEvents(document.body, {
			mousemove: onMouseMove,
			'mouseover [data-card-hover]': onMouseOver,
			'mouseout [data-card-hover]': onMouseOut,
		});
	}

	return () => {
		removeEvents(document.body, {
			mousemove: onMouseMove,
			'mouseover [data-card-hover]': onMouseOver,
			'mouseout [data-card-hover]': onMouseOut,
		});

		document.querySelectorAll('[data-readmore]').forEach(el => {
			el.remove();
		});
	};
}

export default withPlugins(domEvents)(CardHover);
